import styled from "styled-components"

export const Wrapper = styled.section`
  border-radius: 8px;
  background-color: #fbfaf8;
  border: 1px solid #e5e5e5;
`
